// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__cb4Wg","header":"Messages_header__2d0OK"};